<template>
  <span class="position-button-text-variant" data-position-related-button>
  </span>
</template>

<script setup>
import { onMounted, onBeforeUnmount, getCurrentInstance } from 'vue'

let container = null
let button = null

const handleMouseEnter = () => {
  button?.setAttribute('data-hovering', 'true')
}

const handleMouseMove = (e) => {
  const rect = container.getBoundingClientRect()
  const x = e.clientX - rect.left
  const y = e.clientY - rect.top

  button?.style.setProperty('--mouse-x', `${x}px`)
  button?.style.setProperty('--mouse-y', `${y}px`)
}

const handleMouseLeave = () => {
  button?.removeAttribute('data-hovering')
  button?.style.removeProperty('--mouse-x')
  button?.style.removeProperty('--mouse-y')
}

onMounted(() => {
  // Get current DOM element
  const instance = getCurrentInstance()
  if (!instance?.proxy?.$el) return

  button = instance.proxy.$el
  container = button.parentElement

  if (!container || !button) return

  container.addEventListener('mouseenter', handleMouseEnter)
  container.addEventListener('mousemove', handleMouseMove)
  container.addEventListener('mouseleave', handleMouseLeave)
})

onBeforeUnmount(() => {
  if (!container) return
  container.removeEventListener('mouseenter', handleMouseEnter)
  container.removeEventListener('mousemove', handleMouseMove)
  container.removeEventListener('mouseleave', handleMouseLeave)
})
</script>
